import { useRef,useState,useEffect } from 'react';
import { motion, useInView } from 'framer-motion';
import ProductCard from '../Ui/ProductCard';
import { getFeaturedProducts } from '../../services/productService';

const FeaturedProducts = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getFeaturedProducts();
        setProducts(data);
      } catch (error) {
        console.error('Öne çıkan ürünler yüklenemedi:', error);
      }
    };

    fetchProducts();
  }, []);
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="targetSection" className="py-16 bg-white">
      <div className="container-custom" ref={ref}>
        <div className="flex justify-between items-center mb-10">
          <h2 className="section-title">Öne Çıkan Ürünler</h2>
        </div>

        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
{products.slice(0, 6).map((product) => (
  <motion.div key={product.id} variants={itemVariants}>
    <ProductCard product={product} />
  </motion.div>
))}

        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;